import {GetOdontoAvailableTimes} from 'domain/usecases';
import {RemoteGetOdontoAvailableTimes} from 'data/usecases';
import {makeBFFApiUrl} from 'main/factories/http';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {BookingFlowEndPoints} from 'main/factories/usecases/endpoints';

export const makeGetOdontoAvailableTimes = (): GetOdontoAvailableTimes =>
	new RemoteGetOdontoAvailableTimes(
		makeBFFApiUrl(BookingFlowEndPoints.odontoAvailableTimes),
		makeAuthorizeHttpClientDecorator(),
	);
